import { render } from "./CustomSuggest.vue?vue&type=template&id=37697ca0"
import script from "./CustomSuggest.vue?vue&type=script&lang=js"
export * from "./CustomSuggest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__